import { jsxs as o, jsx as l } from "react/jsx-runtime";
const s = (a) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentcolor",
          d: "M11 2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6.586l2.707 2.707A1 1 0 0 0 22 14V4a2 2 0 0 0-2-2z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentcolor",
          d: "M7 9v1a4 4 0 0 0 4 4h4v3a2 2 0 0 1-2 2H6.414l-2.707 2.707A1 1 0 0 1 2 21V11a2 2 0 0 1 2-2z"
        }
      )
    ]
  }
);
export {
  s as default
};
